if (customElements.get('research-database-table') === undefined) {
  class ResearchDatabaseTable extends HTMLElement {
    connectedCallback() {
      this.filtersEl = this.querySelector('[data-rdb-filters]');
      this.searchInput = this.querySelector('[data-rdb-search]');
      this.grid = this.querySelector('[data-rdb-grid]');

      if (!this.grid) return;

      this.grid.style.visibility = 'hidden';
      this.sortByDate();
      this.grid.style.visibility = '';

      this.activeFilter = 'all';
      this.searchQuery = '';

      if (this.filtersEl) {
        this.filtersEl.addEventListener('click', (e) => {
          const btn = e.target.closest('.rdb-filter-btn');
          if (!btn) return;
          this.activeFilter = btn.dataset.filter;
          this.updateActiveBtn(btn);
          this.applyFilters();
        });
      }

      if (this.searchInput) {
        this.searchInput.addEventListener('input', (e) => {
          this.searchQuery = e.target.value.trim().toLowerCase();
          this.applyFilters();
        });
      }
    }

    updateActiveBtn(activeBtn) {
      this.filtersEl.querySelectorAll('.rdb-filter-btn').forEach((btn) => {
        btn.classList.remove('bg-dark-green-default', 'text-white');
        btn.classList.add('bg-white', 'text-dark-green-80', 'border-gray-300');
      });
      activeBtn.classList.add('bg-dark-green-default', 'text-white');
      activeBtn.classList.remove('bg-white', 'text-dark-green-80', 'border-gray-300');
    }

    sortByDate() {
      const cards = Array.from(this.grid.querySelectorAll('[data-entry-type]'));
      cards.sort((a, b) => {
        const dateA = a.dataset.createdAt ? new Date(a.dataset.createdAt).getTime() : 0;
        const dateB = b.dataset.createdAt ? new Date(b.dataset.createdAt).getTime() : 0;
        return dateB - dateA; // newest first
      });
      cards.forEach((card) => this.grid.appendChild(card));
    }

    applyFilters() {
      const cards = this.grid.querySelectorAll('[data-entry-type]');
      cards.forEach((card) => {
        const matchesType = this.activeFilter === 'all' || card.dataset.entryType === this.activeFilter;
        const searchText = card.dataset.searchText || '';
        const matchesSearch = !this.searchQuery || searchText.includes(this.searchQuery);
        card.style.display = matchesType && matchesSearch ? '' : 'none';
      });
    }
  }

  customElements.define('research-database-table', ResearchDatabaseTable);
}
